// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"40":"c2dc78a9","488":"198fe6eb","603":"b1a122a5"}[chunkId] + ".chunk.js";
};